import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@env/environment';
import { GS1NotificationService } from '@gs1france/gs1-components-library';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CodePriceModel } from '../../codes/models/codes-price.model';
import { DetailsCommande } from '../models/details-commande.model';

@Injectable({
  providedIn: 'root'
})
export class PaiementService {
  private _http = inject(HttpClient);
  private notification = inject(GS1NotificationService);

  private __URL_API__ = `${environment.URL_API}`;

  callPaiement(commande: DetailsCommande, selectedListInvoiceNo: string[]): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('prixTtc', commande.ttc !== null ? commande.ttc.toString() : '10');
    formData.append('typePaiement', 'FACTURE');
    formData.append('invoicesNum', selectedListInvoiceNo == undefined ? '' : JSON.stringify(selectedListInvoiceNo));

    return this._http.post(this.__URL_API__ + 'api/Paiement/SendPaiement', formData).pipe(
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }

  getPriceForCode(typeOfCodes: string): Observable<CodePriceModel> {
    return this._http.get<CodePriceModel>(`${this.__URL_API__}api/code/pricing/${typeOfCodes}`).pipe(
      catchError((err) => {
        this.notification.addNotification('Un problème technique est survenu, veuillez réessayer ultérieurement.', 'error');
        console.error(err);
        return of(null);
      })
    );
  }
}
